import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Radio } from "antd";
import {
  commandesListeParCode,
  commandeFiltre,
} from "../actions/commandeActions";
import "../ClientDetail.css";

const ClientDetail = () => {
  const [date_d, setDateD] = useState(new Date());
  const [date_f, setDateF] = useState(new Date());
  const [wFilter, setWFiltre] = useState("T");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { code } = location.state || {};

  const { varGlo } = useSelector((state) => state.chariot);
  const { commandes } = useSelector((state) => state.commandesListeCode);

  useEffect(() => {
    if (varGlo) {
      document.title = varGlo.nom_cli;

      if (wFilter === "R") {
        dispatch(commandeFiltre("Remis"));
      } else if (wFilter === "L") {
        dispatch(commandeFiltre("Livre"));
      } else {
        dispatch(commandesListeParCode(date_d, date_f, code));
      }
    }
  }, [date_d, date_f, wFilter, varGlo, dispatch, code]);

  const existLiv = () => commandes?.some((cmd) => cmd.isLivree);
  const existRemis = () => commandes?.some((cmd) => cmd.cmd_remis);

  return (
    <div className="client-detail-container">
      {varGlo && (
        <div className="client-info">
          <div className="client-info-row">
            <span className="client-info-label">Adresse:</span>
            <span className="client-info-value">{varGlo.adr_cli}</span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Chiffre:</span>
            <span className="client-info-value">
              {varGlo?.chiffre?.toFixed(3)}
            </span>
          </div>
          <div className="client-info-row">
            <span className="client-info-label">Solde:</span>
            <span className="client-info-value">
              {varGlo?.solde?.toFixed(3)}
            </span>
          </div>
          {commandes && (
            <div className="client-info-row">
              <span className="client-info-label">Nombre des Commandes:</span>
              <span className="client-info-value">{commandes?.length}</span>
            </div>
          )}
          <div className="date-view">
            <div className="date-picker">
              <FaCalendarAlt className="calendar-icon" />
              <DatePicker
                selected={date_d}
                onChange={(date) => setDateD(date)}
                selectsStart
                startDate={date_d}
                endDate={date_f}
                dateFormat="dd/MM/yyyy"
                className="date-input"
              />
            </div>
            <div className="date-picker">
              <FaCalendarAlt className="calendar-icon" />
              <DatePicker
                selected={date_f}
                onChange={(date) => setDateF(date)}
                selectsEnd
                startDate={date_d}
                endDate={date_f}
                minDate={date_d}
                dateFormat="dd/MM/yyyy"
                className="date-input"
              />
            </div>
          </div>
          <div className="client-info">
            <Button
              onClick={() =>
                navigate("/ListeFamille", {
                  state: { langue: "F", wcli: varGlo },
                })
              }
            >
              Commander
            </Button>
          </div>
        </div>
      )}

      {commandes && (
        <div className="filter-bar">
          <Radio.Group
            value={wFilter}
            onChange={(e) => setWFiltre(e.target.value)}
            className="radio-group"
          >
            <Radio value="R" disabled={!existRemis() || wFilter === "L"}>
              Remis
            </Radio>
            <Radio value="L" disabled={!existLiv() || wFilter === "R"}>
              Livree
            </Radio>
            <Radio value="T">Tous</Radio>
          </Radio.Group>
        </div>
      )}

      <div className="command-list">
        <div className="command-header">
          <span className="command-header-text">Date Cmd</span>
          <span className="command-header-text">N° Cmd</span>
          <span className="command-header-text">Montant</span>
          <span className="command-header-text">Remis</span>
          <span className="command-header-text">Livrée</span>
        </div>
        <div className="command-scroll-container">
          {commandes &&
            varGlo &&
            commandes.map((comm, index) => (
              <div
                key={index}
                className={`command-item ${index % 2 === 0 ? "even" : "odd"}`}
                onClick={() =>
                  navigate("/commande-detail-cli", { state: { id: comm._id } })
                }
              >
                <span className="command-date">
                  {comm.date_livraison.substring(0, 10)}
                </span>
                <span className="command-id">{comm.commandeId}</span>
                <span className="command-amount">
                  {comm.totalePrix.toFixed(3)}
                </span>
                <FontAwesomeIcon
                  icon={comm.cmd_remis ? faCheck : faX}
                  size="sm"
                  className={`command-icon ${comm.cmd_remis ? "check" : "x"}`}
                />
                <FontAwesomeIcon
                  icon={comm.isLivree ? faCheck : faX}
                  size="sm"
                  className={`command-icon ${comm.isLivree ? "check" : "x"}`}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ClientDetail;
